// extracted by mini-css-extract-plugin
export default {"container":"Tag__container___FyIt1","tag":"Tag__tag___JXF9q"};